import { useState } from "react";
import { api } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Loader2, Flag } from "lucide-react";
import { toast } from "sonner";

const REASONS = [["not_delivered", "Not delivered"], ["damaged", "Items damaged"], ["wrong_location", "Wrong location"], ["late", "Very late"], ["other", "Other"]];

export default function DisputeDeliveryDialog({ job, open, onOpenChange, onDone }) {
  const [reason, setReason] = useState("not_delivered");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/gigs/jobs/${job.job_id}/dispute`, { reason, details }); toast.success(data.payout_held ? "Dispute opened — driver payout is on hold" : "Dispute opened — our team will review"); onDone?.(); onOpenChange(false); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not open dispute"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0B0D12] border-slate-800 max-w-md" data-testid="dispute-delivery-dialog">
        <DialogHeader><DialogTitle className="font-display flex items-center gap-2"><Flag className="w-4 h-4 text-red-400" />Report a problem with this delivery</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-400">The driver's payout is held while our team reviews the proof photo, GPS trail and chat. You have 72 hours after delivery to file.</p>
        <div className="flex flex-wrap gap-1.5">{REASONS.map(([k, l]) => <button key={k} onClick={() => setReason(k)} data-testid={`dispute-reason-${k}`} className={`px-2.5 py-1 rounded-full text-xs border ${reason === k ? "bg-red-500/20 border-red-500/40 text-red-200" : "border-slate-700 text-slate-300 hover:border-slate-500"}`}>{l}</button>)}</div>
        <Textarea value={details} onChange={(e) => setDetails(e.target.value)} placeholder="What happened? (min 10 characters)" data-testid="dispute-details" className="bg-slate-900 border-slate-800 min-h-[90px]" />
        <Button onClick={submit} disabled={busy || details.trim().length < 10} data-testid="dispute-submit-btn" className="bg-red-500 hover:bg-red-600 text-white font-semibold">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Submit dispute"}</Button>
      </DialogContent>
    </Dialog>
  );
}
